<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        valorde: '',
        valorate: '',
        tipoalcadaid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return JSON.parse(JSON.stringify(this.value));
      },
      set(value) {
        this.tempForm = value;
      },
    },
    isRangeValid() {
      const valorde = parseInt(this.tempForm.valorde, 10);
      const valorate = parseInt(this.tempForm.valorate, 10);

      if (isNaN(valorde) || isNaN(valorate)) {
        return true;
      }

      return valorde <= valorate;
    },
  },
  data() {
    return {
      dataFromApiTipoUsuarioId: '',
      tempForm: {},
      rangeError: false,
    };
  },
  mounted() {
    this.fetchDataFromUsuario();
    this.tempForm = JSON.parse(JSON.stringify(this.value));
  },
  methods: {
    async validateForm() {
      if (!this.isRangeValid) {
        this.rangeError = true;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro de validação',
            text: 'O valor de não pode ser maior que o valor até.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      this.rangeError = false;

      if (!this.tempForm.valorde || !this.tempForm.valorate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário incompleto',
            text: 'Preencha todos os campos obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.$emit('ok', this.tempForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromUsuario() {
      try {
        const response = await axios.get('/perfilAcesso/findAll');
        this.dataFromApiTipoUsuarioId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    checkRangeValues() {
      this.rangeError = false;
    },
  },
  watch: {
    'tempForm.valorde': function () {
      this.checkRangeValues();
    },
    'tempForm.valorate': function () {
      this.checkRangeValues();
    },
    value: {
      handler(newVal) {
        this.tempForm = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal"
    :ok-disabled="tempForm.isDefault || !isRangeValid" :ok-title="labelBtnOk"
    ok-variant="success" cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tipo Usuario" label-for="alcadaid">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-select v-model="tempForm.tipousuarioid" id="alcadaid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiTipoUsuarioId" value-field="id" text-field="perfil_acesso_nome"
                  placeholder="Digite o id" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Valor de" label-for="valorde">
              <validation-provider #default="{ errors }" name="valorde" rules="required|regex:^([0-9]+)$" v-mask="'##########'">
                <b-form-input v-model="tempForm.valorde" id="valorde" :state="errors.length > 0 ? false : null"
                  :disabled="tempForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Valor Até" label-for="valorate">
              <validation-provider #default="{ errors }" name="valorate" rules="required|regex:^([0-9]+)$" v-mask="'##########'">
                <b-form-input v-model="tempForm.valorate" id="valorate" :state="errors.length > 0 ? false : null"
                  :disabled="tempForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <small v-if="rangeError || (!isRangeValid && tempForm.valorde && tempForm.valorate)" class="text-danger">
                O valor de não pode ser maior que o valor até.
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1" hidden>
            <b-form-group label="tipoalcadaid" label-for="tipoalcadaid">
              <validation-provider #default="{ errors }" name="valorate" rules="required">
                <b-form-input v-model="tempForm.tipoalcadaid" value="2" id="tipoalcadaid"
                  :state="errors.length > 0 ? false : null" :disabled="tempForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
